import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminAnnouncements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/content/announcements").then((r) => setItems(r.data?.data?.items || [])); }, []);
  const save = async (next) => { setItems(next); await api.put("/content/announcements", { items: next }); toast.success("Announcements updated"); };
  const add = () => save([...items, { id: Math.random().toString(36).slice(2, 8), text: "", active: true }]);
  return (
    <div>
      <h1 className="font-serif-display text-4xl mb-2">Announcements</h1>
      <p className="text-sm text-muted-foreground mb-6">e.g. "Christmas order deadline: 10th December". The first active one shows on the homepage banner via Content → Homepage.</p>
      <div className="space-y-3 max-w-2xl">
        {items.map((it, i) => (
          <div key={it.id} className="bg-white border border-brand-border rounded-sm p-4 flex items-center gap-3" data-testid={`announcement-${i}`}>
            <input type="checkbox" checked={it.active} onChange={(e) => save(items.map((x, j) => j === i ? { ...x, active: e.target.checked } : x))} className="accent-brand-pink" />
            <input value={it.text} onChange={(e) => setItems(items.map((x, j) => j === i ? { ...x, text: e.target.value } : x))} onBlur={() => save(items)} className="flex-1 border border-brand-border rounded-sm px-3 py-2 text-sm" />
            <button onClick={() => save(items.filter((_, j) => j !== i))} className="text-destructive"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        <button onClick={add} className="flex items-center gap-2 bg-brand-ink text-white px-5 py-2.5 rounded-sm text-sm uppercase tracking-luxe hover:bg-brand-pink hover:text-brand-ink transition-colors" data-testid="add-announcement"><Plus className="w-4 h-4" /> Add announcement</button>
      </div>
    </div>
  );
}
